<template lang="pug">
div
  .text-sm.font-semibold.my-6 MEDICAL CERTIFICATE
  .text-xs.text-right Date: 
    span.px-5.underline-content.neutral500--text {{ date }}
  .text-left.my-6
    .text-xs.mb-4 To whom it may concern:
    .text-xs.content I, &nbsp;
      span.neutral500--text {{ doctorName }} &nbsp;
      | have carefully examine Mr/Mrs. &nbsp;
      span.neutral500--text {{ patientName }}
      | ,&nbsp;
      span.neutral500--text {{ nric }}
      | ,&nbsp;
      span.neutral500--text {{ age }} &nbsp;
      | years old. I certify that he/she is suffering from &nbsp;
      span.neutral500--text {{ diagnosis }}
      | . I consider that a period of absence from duty of &nbsp; 
      span.neutral500--text {{ startDate }} &nbsp;
      | until &nbsp;
      span.neutral500--text {{ endDate }} &nbsp;
      | is necessary for the health restoration.
    .text-xs.mt-5.mb-2(v-if="hasDependentPatient") This patient is the dependent of {{ dependentName }}, {{ dependentIc }}
  .text-xs.text-right.mt-10 MC No: 
      span.px-5.underline-content.neutral500--text {{ mcNo }}
</template>

<script>
export default {
  props: {
    medicalCertificateData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    date () {
      if (this.medicalCertificateData?.visit_date) {
        return this.$options.filters.convertToDateOnly(this.medicalCertificateData.visit_date)
      }
      return '{Date}'
    },
    doctorName () {
      return this.medicalCertificateData?.doctor_name || '{Doctor}'
    },
    patientName () {
      return this.medicalCertificateData?.name || '{Patient name}'
    },
    nric () {
      return this.medicalCertificateData?.ic || '{NRIC}'
    },
    age () {
      return this.medicalCertificateData?.age || '{Age}'
    },
    diagnosis () {
      if (this.medicalCertificateData?.diagnosis) {
        return this.medicalCertificateData.diagnosis.join(', ')
      }
      return '{Diagnosis}'
    },
    startDate () {
      if (this.medicalCertificateData?.start_date) {
        return this.$options.filters.convertToDateOnly(this.medicalCertificateData.start_date)
      }
      return '{Start date}'
    },
    endDate () {
      if (this.medicalCertificateData?.end_date) {
        return this.$options.filters.convertToDateOnly(this.medicalCertificateData.end_date)
      }
      return '{End date}'
    },
    mcNo () {
      return '{MC No}'
    },
    noOfDays () {
      return this.medicalCertificateData?.days_count || '{No of days}'
    },
    hasDependentPatient () {
      return this.medicalCertificateData?.patient_dependent
    },
    dependentName () {
      return this.medicalCertificateData?.patient_dependent.name
    },
    dependentIc () {
      return this.medicalCertificateData?.patient_dependent.ic
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  line-height: 25px !important;
}
.underline-content {
  border-bottom: 1px solid var(--v-neutral700);
}
</style>